import React from "react";
import UniversalPhotoButton from "../qforms/standard_elements/UniversalPhotoButton";
import { Collapse, DatePicker, Form, Input } from "antd";
import QurealBasicEditor from "../qureal_editor/QurealBasicEditor";
import { startCase } from "lodash";
import produce from "immer";


const { Panel } = Collapse;

function RenderField({ type, itype, name, label, field, value, onChange }) {
    // const { name, label, itype } = field;

    if (type === "array") {
        return (
            <Form.Item label={label} key={name} name={name}>
                {/* <pre>{JSON.stringify(field, null, 2)}</pre> */}
                <ArrayField field={field} field_key={name}
                />
            </Form.Item>
        );
    }

    switch (itype) {
        case "img":
            return <Form.Item name={name} label={label}>
                {/* <label>{startCase(field_id)}</label> */}
                <UniversalPhotoButton
                    field={{
                        collection: "qqq",
                        field: name,
                    }}
                    width="150px"
                    height="150px"
                    objectFit="contain"
                    show_placeholder={true}
                    background="white"
                    enable_remove_bg={false}
                />
            </Form.Item>
        case "textarea":
            return (
                <Form.Item name={name} label={label} key={name}>
                    <Input.TextArea rows={4} />
                </Form.Item>
            );
        case "array":
            return (
                <Form.Item label={label} key={name} name={name}>
                    {/* <pre>{JSON.stringify(field, null, 2)}</pre> */}
                    <ArrayField field={field} field_key={name}
                    />
                </Form.Item>
            );
        case "number":
            return (
                <Form.Item name={name} label={label} key={name}>
                    <Input type="number" />
                </Form.Item>
            );
        case "html":
            return (
                <Form.Item name={name} label={label} key={name}>
                    <QurealBasicEditor
                    />
                </Form.Item>
            );
        case "date":
            return (
                <Form.Item name={name} label={label} key={name}>
                    <DatePicker />
                </Form.Item>
            )
        case "text":
        default:
            return (
                <Form.Item name={name} label={label} key={name}>
                    <Input />
                </Form.Item>
            );
    }
}

export default RenderField;

function ArrayField({ field, value = [], onChange, field_key }) {
    const properties = field?.items?.properties || {};

    return <Collapse>
        {Array.from({ length: field?.length || 1 }).map((_, i) => {
            const val = value?.[i] || {};
            return <Panel header={`${startCase(field_key)} ${i + 1}`}>
                <Form layout="vertical" initialValues={val} onValuesChange={(changedValues, allValues) => {
                    onChange && onChange(produce(value, (draft) => {
                        if (draft?.length > i) {
                            draft[i] = allValues;
                        }
                    }));
                }}>
                    {Object.keys(properties).map((key, index) => {
                        const inner_field = properties[key];
                        return <RenderField
                            key={key}
                            type={inner_field?.type || "string"}
                            itype={inner_field?.itype || "text"}
                            name={key}
                            label={startCase(key)}
                            field={inner_field}
                        />
                    })}
                </Form>
            </Panel>
        })}
    </Collapse>;
}